import styles from "./AddonItem.module.scss";
import React, { useState } from "react";
import { IAddon } from "../../../../../models/Addon";
import { useTranslation } from "react-i18next";
import CustomButton from "../../../../../components/ui/CustomButton/CustomButton";
import SelectPaymentMethodPopup from "../../../../../components/SelectPaymentMethodPopup/SelectPaymentMethodPopup";

interface IAddonItemProps {
  item: IAddon;
  stripePublicKey: string;
}

const AddonItem: React.FC<IAddonItemProps> = ({ item, stripePublicKey }) => {
  const { t } = useTranslation();

  const [showSelectPaymentMethodPopup, setShowSelectPaymentMethodPopup] = useState<boolean>(false);

  return (
    <>
      <div className={styles.item}>
        <div className={styles.row}>
          <p className={styles.credits}>
            {item.credits} {t("Credits")}
          </p>
          <p className={styles.price}>€{item.price}</p>
        </div>
        <CustomButton
          text={t("BuyNow")}
          type={"button"}
          typeStyle={"fill"}
          functionOnClick={() => setShowSelectPaymentMethodPopup(true)}
        />
      </div>
      {showSelectPaymentMethodPopup && (
        <SelectPaymentMethodPopup
          onClose={() => setShowSelectPaymentMethodPopup(false)}
          purchasingItemId={item.id}
          purchasingItemType={"addon"}
          stripePublicKey={stripePublicKey}
        />
      )}
    </>
  );
};

export default AddonItem;
